import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * The white bordered card that every chart / panel in the design sits inside.
 *
 * `stretch` fills the height of the parent Grid item so cards sharing a row line up.
 * It is opt-in: <main> is a stretched flex item, so a standalone card with height:100%
 * would grow to the full viewport and push everything below it off-screen.
 */
export default function DataCard({ title, subtitle, action, children, sx, bodySx, stretch = false }) {
  return (
    <Paper
      sx={{
        background: 'var(--card)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        boxShadow: 'var(--shadow)',
        p: '18px',
        ...(stretch ? { height: '100%' } : null),
        ...sx,
      }}
    >
      {(title || action) && (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.25 }}>
          <Box sx={{ minWidth: 0 }}>
            {title && (
              <Typography variant="h6" sx={{ m: 0, fontSize: 15, fontWeight: 600 }}>
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography sx={{ m: '2px 0 14px', fontSize: 12, color: 'var(--muted)' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
      )}
      <Box sx={bodySx}>{children}</Box>
    </Paper>
  );
}
